<template>
  <v-container>
    <v-row justify="center" class="mt-6">
      <lottie-player
        src="https://assets10.lottiefiles.com/packages/lf20_6nmazhqu.json"
        background="transparent"
        speed="1"
        style="height: 500px"
        loop
        autoplay
      ></lottie-player>
    </v-row>
    <v-row justify="center">
      <h1>Nothing interesting here</h1>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>